import type { LinearProgressProps } from '@mui/material'

export interface PerformanceTab {
  key: 'applications' | 'approved' | 'loans'
  countKey: 'totalApplications' | 'totalApprovedApplications' | 'totalCreatedLoans'
  amountKey: 'totalApplicationsAmount' | 'totalMaxApprovalAmount' | 'totalGrantedAmount'
  /** Raw color for chart series (accepts any CSS color, not theme-bound). */
  color: string
  /** Theme-bound tone for MUI components that only accept a palette color union (e.g. `StepLinearProgress`). */
  tone: NonNullable<LinearProgressProps['color']>
}

export const PERFORMANCE_TABS: readonly PerformanceTab[] = [
  {
    key: 'applications',
    countKey: 'totalApplications',
    amountKey: 'totalApplicationsAmount',
    // eslint-disable-next-line @if/mui/no-hardcoded-color -- raw chart series color, not theme-bound (see the `color` field doc above)
    color: '#1976d2',
    tone: 'info',
  },
  {
    key: 'approved',
    countKey: 'totalApprovedApplications',
    amountKey: 'totalMaxApprovalAmount',
    // eslint-disable-next-line @if/mui/no-hardcoded-color -- raw chart series color, not theme-bound (see the `color` field doc above)
    color: '#ed6c02',
    tone: 'warning',
  },
  {
    key: 'loans',
    countKey: 'totalCreatedLoans',
    amountKey: 'totalGrantedAmount',
    // eslint-disable-next-line @if/mui/no-hardcoded-color -- raw chart series color, not theme-bound (see the `color` field doc above)
    color: '#2e7d32',
    tone: 'success',
  },
]
